





























































/** @format */
import * as _ from 'lodash';
import FileImportMixin from '@root/common/mixins/import/import.tsx';
import { Component, Mixins, Watch, Vue } from 'vue-property-decorator';
import Utils from '@root/utils/common';
import { storedtemplate, errorExcelExport } from '@/api/fixed-car-management';
import mixedUtils from '@root/common/mixins/list-page/utils.js';
// import ParkingLotSearch from '@/components/parking-lot-search/index.vue'
// axios请求
// import { getRegion } from '@/api/parking-lot-management/index'

// @Component({
//   name: 'longRentalCarList',
//   components: { ParkingLotSearch },
// })
@Component
export default class exportsStord extends Mixins(FileImportMixin) {
  created() {}
  // 下载导入模板
  async downLoadTemplate() {
    try {
      this.downloadLoading = true;
      await storedtemplate({}, '储值卡导入模板');
    } catch (e) {
      console.log('下载失败');
    } finally {
      this.downloadLoading = false;
    }
  }
  handleAddBtnClick() {
    mixedUtils.closestVM(this, 'filterParam').handleNewBtnClick();
  }
  downloadLoading = false;
  tableVisiter = false;
  errMsg = false;
  keyword = '';
  downLoadErrMsgLoading = false;
  errMsgdes = '';
  // 导入弹框
  showTableErr(e) {
    try {
      // console.log(e, 'error---------->')
      this.tableVisiter = true;
      this.errMsg = true;
      // this.dataErrList = e.data
      this.keyword = e.data;
      this.errMsgdes = e.msg;
    } catch (e) {
      console.log(e);
    }
  }
  handleCancel() {
    this.tableVisiter = false;
  }
  showBtnErr(e: any) {
    this.errMsg = true;
    console.log(e);
    this.keyword = e.data;
    this.errMsgdes = e.msg;
  }
  renderFetchTableData() {
    // this.fetchTableData()
    this.$emit('fetchTableData');
    this.tableVisiter = false;
  }
  async downLoadErrMsg() {
    try {
      if (this.downLoadErrMsgLoading) return;
      this.downLoadErrMsgLoading = true;
      const res = await errorExcelExport({ keyword: this.keyword });
      console.log(res);
    } catch (e) {
      console.log(e);
    } finally {
      this.downLoadErrMsgLoading = false;
    }
  }
}
